import * as React from "react";
import Button from "@material-ui/core/Button";
import {Link, useHistory} from "react-router-dom";

import styles from "./css/home.module.scss";
import firebase from "firebase";
import {SetUserInfo, SetAuthTokenAction, SetUidAction} from "../../actions";
import {login} from "../../util/api";
import {googleProvider} from "../../util/firebase";
import {useDispatch} from "react-redux";
import {GoogleIcon} from "../GoogleIcon";

export const HomeComponent: React.SFC = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const loginEvent = async () => {
        try {
            await firebase.auth().signInWithPopup(googleProvider);
            const token = await firebase.auth().currentUser!.getIdToken(true);
            const userId = await firebase.auth().currentUser!.uid;
            const userInfo = await login(token);
            dispatch(SetUserInfo(userInfo));
            dispatch(SetAuthTokenAction(token));
            dispatch(SetUidAction(userId));
            history.push("dock");
        } catch (error) {
            alert("認証に失敗しました。");
            console.error(error);
        }
    };

    return (
        <div className={styles.container}>
            ログインしてSocial Dockを使いこなそう！
            <Link style={{fontSize: "18px"}} to="/lp">
                Social Dockとは？
            </Link>
            <div className={styles.buttonWrapper}>
                <Link style={{textDecoration: "none"}} to="/demo">
                    <Button
                        className={styles.goToDemo}
                        variant="contained"
                        size="large"
                    >
                        デモを見る
                    </Button>
                </Link>
                <Button
                    className={styles.loginButton}
                    variant="contained"
                    size="large"
                    startIcon={<GoogleIcon />}
                    onClick={() => {
                        loginEvent();
                    }}
                >
                    Googleアカウントでログイン
                </Button>
            </div>
        </div>
    );
};
